<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn-toggle max="0" background-color="primary" dark>
          <v-btn small text @click="dialog = true">Create Client</v-btn>
          <create-user v-if="$store.getters['auth/isAdmin']"></create-user>
          <upload-games v-if="$store.getters['auth/isAdmin']"></upload-games>
          <upload-files v-if="$store.getters['auth/isAdmin']"></upload-files>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row>
      <v-col col="6">
        <h1>Welcome
          <simple-chip v-if="auth.profile" color="primary" :text="auth.profile.user.email" :icon="{left: 'fa-user'}">
          </simple-chip>
        </h1>
        <h3 v-if="session">Client
          <simple-chip color="primary" :text="$store.getters['session/clientName']" v-on:right-action="close"
            :icon="{left: 'fa-user', right: 'fa-times-circle'}"></simple-chip>
        </h3>
        <h4 v-else>
          Displaying all games for all clients.
        </h4>
        <v-spacer class="ma-2"></v-spacer>
      </v-col>
    </v-row>
    <client-list :logoClient="logoClient" :clientName="clientName"></client-list>
    <v-row>
      <v-col>
        <table-games></table-games>
      </v-col>
    </v-row>
    <!-- Dialogs -->
    <dia-client :dialog="dialog" :isCreating="true" :client="client" @cancel="cancel"></dia-client>
  </v-container>
</template>

<script>
  // @ is an alias to /src
  // Action / dialog components
  import createUser from '@/dialogs/createUser'
  import diaClient from '@/dialogs/diaClient'
  import uploadFiles from '@/dialogs/uploadFiles'
  import uploadGames from '@/dialogs/uploadGames'

  // List components
  import clientList from '@/components/lstClient'
  
  // Testing new data table
  import tableGames from '@/components/tabGames'

  // Other components
  import simpleChip from '@/components/chpSimple'
  import {
    mapState
  } from 'vuex'

  export default {
    name: 'Home',
    data() {
      return {
        dialog: false,
        client: {},
        logoClient: "",
        clientName: "",
      }
    },
    components: {
      createUser,
      diaClient,
      uploadFiles,
      uploadGames,
      clientList,
      simpleChip,
      tableGames
    },
    computed: {
      ...mapState('session', ['session']),
      ...mapState('clients', ['clients']),
      ...mapState('auth', ['auth']),
    },
    methods: {
      close() {
        this.$store.dispatch('session/update', null)
        this.$router.go()
      },
      cancel(logoUrl, clientName) {
        this.dialog = false
        this.file = null
        this.client = {}
        this.isUpdating = false
        this.isRemoving = false
        this.logoClient = logoUrl
        this.clientName = clientName
      },
    },
    created() {
      this.$store.dispatch('reload')
    }
  }
</script>